import { type PropsWithChildren, useCallback, useState } from 'react';

import { ConversorMlhEGotasContext } from './context';
import { EConversorMlhEGotasType } from './IUseConversorMlhEGotas';

export const ConversorMlhEGotasProvider = ({ children }: PropsWithChildren) => {
  const [quantity, setQuantity] = useState<number>(15);
  const [type, setType] = useState<EConversorMlhEGotasType>(
    EConversorMlhEGotasType.MlHour,
  );

  const handleQuantity = useCallback((value: number): void => {
    setQuantity(value);
  }, []);

  const handleType = useCallback((value: EConversorMlhEGotasType): void => {
    setType(value);
  }, []);

  return (
    <ConversorMlhEGotasContext.Provider
      value={{
        quantity,
        type,
        setQuantity: handleQuantity,
        setType: handleType,
      }}>
      {children}
    </ConversorMlhEGotasContext.Provider>
  );
};
